import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { Loader } from '@creditsights/styleguide-web';
import styles from './ContactInformation.module.scss';
import { CONTACT_US_LINK } from '../LockedContent/LockedContent.constants';
import useFetchUserProfile from '../../hooks/profile/useFetchUserProfile';
import { DEFAULT_SUBSCRIPTIONS_EMAIL_ADDRESS } from './ContactInformation.constants';

const cx = classNames.bind(styles);

interface ContactInformationProps {
  showClientService?: boolean;
  showAssignedSalesPerson?: boolean;
  emailAddress?: string;
}

const ContactInformation = ({
  showClientService = true,
  showAssignedSalesPerson = true,
  emailAddress = DEFAULT_SUBSCRIPTIONS_EMAIL_ADDRESS,
}: ContactInformationProps): ReactElement => {
  const { data: profile, isLoading: isLoadingUserProfile } = useFetchUserProfile();
  const email = (showAssignedSalesPerson ? profile?.assignedSalesPerson?.email : null) ?? emailAddress;

  if (isLoadingUserProfile) {
    return <Loader position="center" />;
  }
  const renderClientService = () => {
    if (showClientService) {
      return (
        <>
          {' or '}
          <b className={cx('body')} data-testid="contact-information-additional">
            <a className={cx('link')} href={CONTACT_US_LINK} target="_blank" rel="noreferrer">
              Client Services
            </a>
          </b>
        </>
      );
    }
    return null;
  };
  return (
    <>
      <b className={cx('body')} data-testid="contact-information">
        <a className={cx('link')} href={`mailto:${email}`}>
          {email}
        </a>
      </b>
      {renderClientService()}
    </>
  );
};

export default ContactInformation;
